/**
 * Navigation Data
 * Contains navigation menu items with icons
 */

import { FaHome, FaUserCircle, FaBriefcase, FaGraduationCap, FaCogs, FaBookOpen, FaEnvelope } from 'react-icons/fa';
// import { FaPalette } from 'react-icons/fa'; // DISABLED - UI Demo temporarily disabled
import { SiXdadevelopers } from 'react-icons/si';
import type { NavigationItem } from '@/types';

export const navItems: NavigationItem[] = [
  { id: "hero", label: "Home", icon: FaHome },
  { id: "about", label: "About", icon: FaUserCircle },
  { id: "experience", label: "Experience", icon: FaBriefcase },
  { id: "education", label: "Education", icon: FaGraduationCap },
  { id: "projects", label: "Projects", icon: SiXdadevelopers },
  { id: "skills", label: "Skills", icon: FaCogs },
  { id: "publications", label: "Publications", icon: FaBookOpen },
  { id: "contact", label: "Contact", icon: FaEnvelope },
  // { id: "ui-demo", label: "UI Demo", icon: FaPalette } // Temporary - for testing UI library (DISABLED)
];

